/* eslint-disable import/prefer-default-export */
import styled from "styled-components";
import { Loader } from "Common/Components";

export const LOADER = styled(Loader)``;
